import styled from 'styled-components';

export const GlobalSearchResult = styled.div`
  position: absolute;
  background-color: ${({ theme }) =>
    theme.colours.canvas.tertiary.main} !important;
  box-shadow: ${({ theme }) =>
    theme.isDark ? 'none' : theme.effects.dropShadow.regular};
  overflow-y: scroll;
  max-height: 300px;
  border: 0 !important;
  border-radius: 0 !important;

  .result {
    height: 1.875rem;
    line-height: 2;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;

    &:hover,
    &.active {
      background: ${({ theme }) =>
        theme.colours.canvas.secondary.strong} !important;
      color: ${({ theme }) => theme.colours.ink.primary.main} !important;
    }

    a {
      background: none;
      justify-content: flex-start;
      padding: ${({ theme }) =>
        `${theme.sizing.xtiny} ${theme.sizing.regular}`};
      color: ${({ theme }) => theme.colours.ink.primary.main} !important;
      text-decoration: none;
      font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
      font-weight: ${({ theme }) => theme.typography.bodyMedium.fontWeight};

      &:hover {
        color: ${({ theme }) => theme.colours.ink.primary.main} !important;
      }
    }
  }
`;
GlobalSearchResult.displayName = 'GlobalSearchResult';
